import React from "react";
import "./organization-access-code-item.scss";

import { GSInfoGroup, GSButton } from "golfstatus_react_components";

import { getDateTime } from "../../helpers/Dates";

const OrganizationAccessCodeItem = (props) => {
  const {
    identifier,
    activateOn,
    deactivateOn,
    maxUseQuantity,
    accessMember,
    status,
  } = props;

  const getInfoGroup = () => {
    let infoSections = {
      fit: "stretch",
      sections: [
        {
          sectionItems: [{ type: "primary", value: identifier }],
        },
        {
          sectionItems: [
            {
              type: "secondary",
              value: maxUseQuantity
                ? `${maxUseQuantity} Available`
                : "Unlimited Use",
            },
          ],
        },
      ],
    };

    if (accessMember) {
      infoSections.sections.splice(1, 0, {
        sectionItems: [
          { type: "secondary", value: `${accessMember?.firstName} ${accessMember?.lastName}`},
          {
            type: "secondary",
            value: accessMember.email,
          },
          {
            type: "secondary",
            value: accessMember.ghinNumber,
          },
        ],
      });
    }

    if (activateOn && deactivateOn) {
      infoSections.sections?.push?.({
        sectionItems: [
          {
            type: "secondary",
            value: `Activates on ${getDateTime(activateOn)}`,
          },
          {
            type: "secondary",
            value: `Deactivates on ${getDateTime(deactivateOn)}`,
          },
        ],
      });
    }

    return [
      { ...infoSections },
      {
        sections: [
          {
            sectionItems: [
              {
                type: "",
                value: (
                  <GSButton
                    type={`status secondary pill ${status}`}
                    title={status}
                  />
                ),
              },
            ],
          },
        ],
      },
    ];
  };
  return (
    <organization-access-code-item>
      <GSInfoGroup dataGroups={getInfoGroup()} />
    </organization-access-code-item>
  );
};

export default OrganizationAccessCodeItem;
